// extracted by mini-css-extract-plugin
export default {"mobileGroup":"AppMenuGroup_mobileGroup__WMtTr","mobileGroupItems":"AppMenuGroup_mobileGroupItems__NuohE","Title":"AppMenuGroup_Title__H+mZW"};